import React from 'react';

import _ from 'lodash';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { fetchMe, failFetchMe } from './ducks/index.js';
import { fetchConstants } from './ducks/constants';

import WithUser from 'shared/HOCs/WithUser';

import Loader from 'shared/components/Loader';

const FetchInitials = WrappedComponent => {
  class HOC extends React.Component {
    componentDidMount() {
      const { constants, fetchConstants, fetchMe, failFetchMe } = this.props;

      if (_.isEmpty(constants)) {
        fetchConstants();
      }

      if (localStorage.getItem('token')) {
        fetchMe();
      } else {
        failFetchMe();
      }
    }
    render() {
      const {
        constants,
        user,
        loadingUser,
        initialCallMade,
        ...rest
      } = this.props;
      const waitingForUser = localStorage.getItem('token') && _.isNil(user);

      if (_.isEmpty(constants) || (waitingForUser && !initialCallMade)) {
        return <Loader />;
      } else {
        return <WrappedComponent {...rest} user={user} />;
      }
    }
  }

  const mapStateToProps = state => {
    return {
      loadingUser: state.me.loading,
      constants: state.constants.constants,
      initialCallMade: state.me.initialCallMade
    };
  };

  const mapDispatchToProps = {
    fetchMe,
    failFetchMe,
    fetchConstants
  };

  return compose(
    WithUser,
    connect(
      mapStateToProps,
      mapDispatchToProps
    )
  )(HOC);
};

export default FetchInitials;
